.container {
  display: flex;
  gap: 16px;
  align-items: center;
}

.input {
  width: 80px;

  input {
    width: 100%;
  }
}
